import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import { GeoanalysisDefinitionIcon, KpiDefinitionIcon, QueryDefinitionIcon } from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const ManagementDefinition = () => {

  const data = [
    {
      name: getLocalizedString("queryDefinition"),
      icon: <QueryDefinitionIcon />,
      path: paths.queryDefinition,
    },
    {
      name: getLocalizedString("kpiDefinition"),
      icon: <KpiDefinitionIcon />,
      path: paths.kpiDefinition,
    },
    {
      name: getLocalizedString("geoQuery"),
      icon: <GeoanalysisDefinitionIcon />,
      path: paths.geoQuery,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("managementDefinition")}
      data={data}
    />
  );
}

export default ManagementDefinition;
